var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeglasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 1.00003C2.07299 0.992753 0.743414 2.47219 0.750026 4.10347L0.75 15.5M21.75 1.00003C23.427 0.992753 24.7566 2.47219 24.75 4.10347V15.5M24.75 15.5C24.75 17.9853 22.7353 20 20.25 20C17.7647 20 15.75 17.9853 15.75 15.5M24.75 15.5C24.75 13.0147 22.7353 11 20.25 11C17.7647 11 15.75 13.0147 15.75 15.5M9.75 15.5C9.75 17.9853 7.73528 20 5.25 20C2.76472 20 0.75 17.9853 0.75 15.5M9.75 15.5C9.75 13.0147 7.73528 11 5.25 11C2.76472 11 0.75 13.0147 0.75 15.5M9.75 15.5H15.75",
    stroke: "#393A40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeglasses);
export default __webpack_public_path__ + "static/media/eyeglasses.5b587724beb259404aee115681cdb76a.svg";
export { ForwardRef as ReactComponent };